import { styled as styledLinaria } from '@linaria/react'

export const headerComponentHeight = 45

export const Wrapper = styledLinaria.nav`
  display: flex;
  position: relative;  
  justify-content: space-between;
  align-items: center;
  height: ${headerComponentHeight}px;
  min-height: ${headerComponentHeight}px;
`

export const Text = styledLinaria.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
`
export const Row = styledLinaria.div`
  position: relative;
  display: flex;
  align-items: center;  
`
